<h1 *ngIf="!players" class="px-2 mx-auto">Loading...</h1>
<section *ngIf="players" class="flex flex-col px-2 justify-evenly">
  <div class="flex flex-row flex-wrap justify-center flex-grow mt-2">
    <a
      *ngIf="!showAll"
      [routerLink]="['/player/list']"
      [queryParams]="{ sort: sortKey, dir: sortDirection }"
      class="inline-block px-4 py-2 mx-1 leading-none text-white bg-gray-800 border border-white rounded hover:border-orange-300 hover:text-orange-300"
    >
      Alle anzeigen
    </a>
    <a
      *ngIf="showAll"
      [routerLink]="['/player/list']"
      [queryParams]="{
        showActive: true,
        sort: sortKey,
        dir: sortDirection
      }"
      class="inline-block px-4 py-2 mx-1 leading-none text-white bg-gray-800 border border-white rounded hover:border-orange-300 hover:text-orange-300"
    >
      Nur aktive anzeigen
    </a>
  </div>
  <div class="flex flex-col px-2 justify-evenly xl:hidden">
    <div
      *ngFor="let player of players"
      class="flex-grow max-w-xl p-2 mx-auto mt-4 bg-gray-700 border-4 border-gray-700 rounded-lg"
    >
      <div class="grid grid-cols-4 gap-1 p-1 bg-black">
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Name
        </div>
        <div
          class="col-span-3 px-2 text-center border border-gray-800 border-solid"
        >
          <a [routerLink]="['/player', player.id]">
            <span [innerHTML]="player.name | safeHtml"> </span>
            ({{ player.id }})
          </a>
        </div>

        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Allianz
        </div>
        <div
          class="col-span-3 px-2 text-center border border-gray-800 border-solid"
        >
          <a
            *ngIf="player.alliance"
            [routerLink]="['/alliance', player.alliance.id]"
          >
            <span [innerHTML]="player.alliance.name | safeHtml"> </span>
            ({{ player.alliance.id }})
          </a>
          <ng-container *ngIf="!player.alliance">-</ng-container>
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Ansehen
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.reputation }}
        </div>
        <div
          class="col-span-2 px-2 bg-gray-800 border border-gray-800 border-solid"
        >
          Punkte
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Gesamt
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ getTotalPoints(player) }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Level
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.level }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Wissenschaft
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.research }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Runden
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.ticks }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Geselschaft
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.society }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktualisiert
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.updatedAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Wirtschaft
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.economy }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Erstellt
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Militär
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.military }}
        </div>
      </div>
    </div>
  </div>
  <table class="hidden mt-4 border-separate xl:table">
    <thead class="">
      <tr class="">
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Name
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'id'"
          [attr.aria-label]="getSortLabel('id')"
          (click)="setSort('id')"
        >
          Id {{ getSortMarker('id') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'reputation'"
          [attr.aria-label]="getSortLabel('reputation')"
          (click)="setSort('reputation')"
        >
          Ansehen {{ getSortMarker('reputation') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'level'"
          [attr.aria-label]="getSortLabel('level')"
          (click)="setSort('level')"
        >
          Level {{ getSortMarker('level') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'ticks'"
          [attr.aria-label]="getSortLabel('ticks')"
          (click)="setSort('ticks')"
        >
          Runden {{ getSortMarker('ticks') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'points'"
          [attr.aria-label]="getSortLabel('points')"
          (click)="setSort('points')"
        >
          Punkte gesamt {{ getSortMarker('points') }}
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Allianz
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'pointsResearch'"
          [attr.aria-label]="getSortLabel('pointsResearch')"
          (click)="setSort('pointsResearch')"
        >
          Wissenschaft {{ getSortMarker('pointsResearch') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'pointsSociety'"
          [attr.aria-label]="getSortLabel('pointsSociety')"
          (click)="setSort('pointsSociety')"
        >
          Geselschaft {{ getSortMarker('pointsSociety') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'pointsEconomy'"
          [attr.aria-label]="getSortLabel('pointsEconomy')"
          (click)="setSort('pointsEconomy')"
        >
          Wirtschaft {{ getSortMarker('pointsEconomy') }}
        </th>
        <th
          class="px-2 bg-gray-800 border border-gray-800 border-solid cursor-pointer select-none hover:text-orange-300"
          [class.text-orange-300]="sortKey === 'pointsMilitary'"
          [attr.aria-label]="getSortLabel('pointsMilitary')"
          (click)="setSort('pointsMilitary')"
        >
          Militär {{ getSortMarker('pointsMilitary') }}
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktualisiert
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Erstellt
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let player of players">
        <td class="px-2 border border-gray-800 border-solid">
          <a
            [routerLink]="['/player', player.id]"
            [innerHTML]="player.name | safeHtml"
          >
          </a>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.id }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.reputation }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.level }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.ticks }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ getTotalPoints(player) }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          <a
            *ngIf="player.alliance"
            [routerLink]="['/alliance', player.alliance.id]"
          >
            <span [innerHTML]="player.alliance.name | safeHtml"> </span>
            ({{ player.alliance.id }})
          </a>
          <ng-container *ngIf="!player.alliance">-</ng-container>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.research }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.society }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.economy }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.points.military }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.updatedAt | date: "dd.MM.yyyy HH:mm" }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ player.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </td>
      </tr>
    </tbody>
  </table>
</section>
